import { BillingDocumentTypes, InstallDocumentTypes, InstallPackageFileCategory } from 'types';

import FormSection from '../Forms/FormSection';
import { DocumentList } from '../MilestonePackagePartials/Documents/DocumentList';

type InvoiceBomDocumentProps = {
  showCheckboxes?: boolean;
  checkboxCategories?: InstallPackageFileCategory[];
  isPackageEditable?: boolean;
};

export const InvoiceBomDocument = ({
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
}: InvoiceBomDocumentProps) => {
  return (
    <FormSection
      title="Invoice/BOM Document"
      description="Upload the invoice or Bill of Materials for this project. These documents are required to be uploaded for the project to be approved."
    >
      <DocumentList
        documentTypeFilter={[
          InstallDocumentTypes.invoice,
          InstallDocumentTypes.billOfMaterials,
          BillingDocumentTypes.incomingDirectPayInvoice,
        ]}
        title="Invoice/BOM Document"
        showTypeLabelOnItems={true}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        baseCategory={InstallDocumentTypes.invoiceOrBom}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  );
};
